"use strict";

var _toConsumableArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/toConsumableArray");

var _joi$default$string;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.schema = exports.optionType = void 0;

require("source-map-support/register");

var _joi = _interopRequireDefault(require("@hapi/joi"));

var _defaultFormatter = _interopRequireDefault(require("./defaultFormatter"));

var optionType = {
  NUMBER: 'number',
  STRING: 'string',
  BOOLEAN: 'boolean'
};
exports.optionType = optionType;

var schema = _joi.default.object().keys({
  name: _joi.default.string().required(),
  description: _joi.default.string().default(''),
  synopsis: _joi.default.string().default(''),
  usage: _joi.default.string().default(''),
  options: _joi.default.object().pattern(/^[a-zA-Z0-9]$/, _joi.default.object().keys({
    alias: _joi.default.string().required(),
    description: _joi.default.string().required(),
    type: (_joi$default$string = _joi.default.string()).valid.apply(_joi$default$string, _toConsumableArray(Object.values(optionType))).required(),
    required: _joi.default.boolean().default(false),
    default: _joi.default.any(),
    // TODO should make sure this is the same type as defined above
    valid: _joi.default.func().default(function () {
      return function () {
        return true;
      };
    })
  })).default({}),
  format: _joi.default.func().default(function () {
    return _defaultFormatter.default;
  }),
  execute: _joi.default.func().required()
});

exports.schema = schema;
var _default = {
  validate: function validate(command) {
    return schema.validate(command);
  }
};
exports.default = _default;